import type {ReactNode} from 'react'
import {ExpandableContainer} from '@freckle/educator-materials/ts/components/expandable-container'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {details, learnMore} from './clean-up-row.module.scss'

type Props = {
  children: ReactNode
}

export function LearnMore(props: Props) {
  const {children} = props
  const {t} = useSafeTranslation()

  return (
    <ExpandableContainer
      expandableComponent={<div className={details}>{children}</div>}
      theme="basic"
      chevronPosition="left"
      iconExpand="down"
      iconCollapse="right"
    >
      {() => <span className={learnMore}>{t('LEARN_MORE_EXPANDABLE_CONTAINER')}</span>}
    </ExpandableContainer>
  )
}
